import cc from 'classcat';
import { createArray } from 'utils/helpers/create-fake-array';
import { ADVANCED_EVENTS_DEFAULT_COUNT } from 'newelements/Sportsbook/layouts/advanced/Desktop/__partials/AdvancedMatchCard/EventsRow';
import { GlobalIcon } from 'components/GlobalIcon';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

export const AdvancedMatchCardSkeleton = ({ isLive }: { isLive?: boolean }) => {
  return (
    <div className="advancedMatchCard">
      <div className="advancedMatchCard__header">
        <Skeleton.Button active style={{ width: 80, height: 24 }} />

        <span className="advancedMatchCard__header__regionInfo">
          <Skeleton.Button
            active
            style={{ height: 20, width: 20, minWidth: 20, margin: 0 }}
            shape="circle"
          />
          <Skeleton
            active
            title={{ style: { width: 180, height: 20, margin: 0 } }}
            paragraph={false}
          />
        </span>
      </div>
      <div className="advancedMatchCard__main">
        <div
          className={cc([
            'advancedMatchCard__main__matchInfo',
            {
              'advancedMatchCard__main__matchInfo--live': isLive
            }
          ])}
        >
          <div
            className={cc([
              'advancedMatchCard__teamsInfo',
              {
                'advancedMatchCard__teamsInfo--live': isLive
              }
            ])}
          >
            <div className="advancedMatchCard__teamsInfo__team">
              <div className="advancedMatchCard__teamsInfo__team__name">
                <Skeleton.Button
                  active
                  shape="square"
                  style={{ height: 20, width: 20, minWidth: 20 }}
                />
                <Skeleton.Button active style={{ width: 80, height: 20 }} />
              </div>
              {isLive && (
                <div className="advancedMatchCard__teamsInfo__team__score">
                  <Skeleton.Button
                    active
                    shape="square"
                    style={{ height: 20, width: 10, minWidth: 10 }}
                  />
                </div>
              )}
            </div>
            <div className="advancedMatchCard__teamsInfo__team">
              <div className="advancedMatchCard__teamsInfo__team__name">
                <Skeleton.Button
                  active
                  shape="square"
                  style={{ height: 20, width: 20, minWidth: 20 }}
                />
                <Skeleton.Button active style={{ width: 80, height: 20 }} />
              </div>
              {isLive && (
                <div className="advancedMatchCard__teamsInfo__team__score">
                  <Skeleton.Button
                    active
                    shape="square"
                    style={{ height: 20, width: 10, minWidth: 10 }}
                  />
                </div>
              )}
            </div>
          </div>
          <div
            className={cc([
              'advancedMatchCard__iconsGroup advancedMatchCard__iconsGroup',
              {
                'advancedMatchCard__iconsGroup--withBorder': !isLive
              }
            ])}
          >
            <div className="advancedMatchCard__iconsGroup__col">
              <Skeleton.Button
                active
                shape="square"
                style={{ height: 20, width: 20, minWidth: 20 }}
              />
              <Skeleton.Button
                active
                shape="square"
                style={{ height: 20, width: 20, minWidth: 20 }}
              />
            </div>
            <div className="advancedMatchCard__iconsGroup__col">
              <Skeleton.Button
                active
                shape="square"
                style={{ height: 20, width: 20, minWidth: 20 }}
              />
              <Skeleton.Button
                active
                shape="square"
                style={{ height: 20, width: 20, minWidth: 20 }}
              />
            </div>
          </div>
        </div>
        <div className="advancedMatchCard__main__oddsWrapper">
          {createArray(ADVANCED_EVENTS_DEFAULT_COUNT).map(item => (
            <div key={item} className="advancedMatchCard__eventsRow">
              {createArray(ADVANCED_EVENTS_DEFAULT_COUNT).map(odd => (
                <Skeleton.Button
                  className="advancedMatchCard__eventsRow__oddSkeleton"
                  key={odd}
                  active
                  shape="square"
                  style={{
                    height: 32,
                    width: 30,
                    minWidth: 30,
                    flex: '1 1'
                  }}
                />
              ))}
            </div>
          ))}
        </div>
        <div className="advancedMatchCard__main__expandIcon">
          <GlobalIcon
            color="var(--v3-black-45)"
            lib="generic"
            name="caretDown"
            theme="default"
            size={12}
            className="advancedMatchCard__expand"
          />
        </div>
      </div>
    </div>
  );
};
